import { z } from 'zod';
/**
 * A plain date: a calendar day, carrying no time of day, no zone, and no offset — a birthday, an
 * anniversary, a holiday on a fixed month and day. It labels a day on the civil calendar rather
 * than marking an instant, so it must not move when a user travels or when DST arrives.
 *
 * Notable publishes plain dates as midnight timestamps. This is unique to us, it is not how plain
 * dates are normally represented, and it is a standing source of bugs. Postgres holds `2020-04-20`
 * in a `date` column; knex parses that into a `Date` at midnight in the server's zone — UTC
 * everywhere we deploy — and JSON renders it as `2020-04-20T00:00:00.000Z`. Every zone-aware read
 * west of UTC then lands on the day before, and no standard formatter saves you:
 *
 * ```
 * format(new Date('2020-04-20'), 'yyyy-MM-dd');                                // '2020-04-19'
 * formatInTimeZone(new Date('2020-04-20'), 'America/New_York', 'yyyy-MM-dd');  // '2020-04-19'
 * ```
 *
 * So read the date part in UTC — `formatInTimeZone(value, 'UTC', 'yyyy-MM-dd')` from `date-fns-tz`
 * — never through the local zone. Both the bare `2020-04-20` and the midnight form are accepted:
 * which one a consumer sees depends on the API it called, and new endpoints are free to move to
 * the bare form.
 *
 * Straightening out the rest means changing how knex parses `date` columns, which reaches every
 * plain date in the product. Until that review happens, this schema is how we state what we serve.
 *
 * @see https://notable-health.atlassian.net/wiki/spaces/notableengineering/pages/3979739157/00.04+-+Plain+Date+Guidelines
 */
export const NotablePlainDateAsMidnightUtcSchema = z.union([z.iso.date(), z.iso.datetime()]);
//# sourceMappingURL=plainDate.js.map